module.exports = __webpack_public_path__ + "static/media/instagram.d08bce0d.svg";